export default __webpack_public_path__ + "static/media/googlePlayAvailable.eeba27db.png";